export function LoadingPage(): React.ReactElement {
  return <main className="p-0 d-flex flex-column"></main>;
}
